import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import ReasonsDropdownItem from './ReasonsDropdownItem';
import css from './ReasonsDropdownList.css';

export default class ReasonsDropdownList extends React.Component {
  render() {
    const { appointmentTypes, value, onReasonSelected } = this.props;
    if ( !appointmentTypes ) return null;
    return (
      <div className={css['list']} data-role="reasonsContainer">
        {appointmentTypes.map((appointmentType, i) => (
          <ReasonsDropdownItem 
            key={i}
            radioName={`radio-group-${i}`} 
            value={value} 
            onReasonSelected={onReasonSelected} 
            {...appointmentType}
          />
        ))}
      </div>
    );
  }
}

ReasonsDropdownList.propTypes = {
  appointmentTypes: PropTypes.array,
  value: SFEntityID,
  onReasonSelected: PropTypes.func.isRequired
};
